import type { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { useCallback } from "react";
import { IPage } from "./types";

export const useDesktopButtonSx = (): ((
  page: IPage | null,
  theme: Theme,
) => SystemStyleObject<Theme>) => {
  const selectedRoute =
    typeof window === "undefined" ? undefined : window.location.pathname;

  const routeSelected = useCallback(
    (page: IPage | null) => selectedRoute === page?.routes?.main,
    [selectedRoute],
  );

  return useCallback(
    (page: IPage | null, theme: Theme): SystemStyleObject<Theme> => {
      const isBlue = page?.isBlue;
      const boxShadow = `inset 0 3px 0 ${isBlue ? theme.palette.common.white : theme.palette.primary.light}`;

      return {
        color: isBlue ? "common.white" : "common.black",
        backgroundColor: isBlue ? "primary.main" : "common.white",
        textDecoration: "none",
        fontFamily: "Lexend",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        // box shadow as  an "interior" border
        // https://stackoverflow.com/a/18841365/6410635
        boxShadow: routeSelected(page) ? boxShadow : "none",

        borderLeft: !isBlue
          ? `1px solid ${theme.palette.secondary.main}`
          : `1px solid ${theme.palette.common.white}`,
        borderRadius: 0,
        padding: "0 25px", // coned.com
        minHeight: {
          xs: "100%",
          sm: "90px",
        },
        width: {
          sm: "10ch",
          lg: "150px",
        },

        "&:hover": {
          boxShadow: page ? boxShadow : "none",
          textDecoration: isBlue ? "underline" : "none",
        },
      } as SystemStyleObject<Theme>;
    },
    [routeSelected],
  );
};
